import { h } from "preact";
import { useLocationFormStorage } from "./locationFormContext";

export function LocationInput() {
  const {
    location,
    setLocation,
    setGeoItem,
    showAutocompleteOverlay,
    setShowAutocompleteOverlay,
  } = useLocationFormStorage();

  const handleInput = (e) => {
    const val = e.target.value;
    setLocation(val);

    if (val.trim().length >= 3) {
      setShowAutocompleteOverlay(true);
    } else {
      setShowAutocompleteOverlay(false);
    }
  };

  const handleFocus = () => {
    if (location && location.trim().length >= 3) {
      setShowAutocompleteOverlay(true);
    }
  };

  const handleReset = () => {
    setLocation("");
    setGeoItem(null);
    setShowAutocompleteOverlay(false);
  };

  return (
    <div
      id="locationFormLocationInput"
      className="inputfield col-span-1 md:col-span-1 relative z-20 transition"
    >
      <div className="inputfield__inputcontainer">
        <label
          className="inputfield__inputcontainer-label required left-8"
          htmlFor="search_form_location"
        >
          {global.Translator.trans("locationform.location", {}, "js")}
        </label>
        <input
          aria-autocomplete="list"
          aria-haspopup="listbox"
          aria-controls="search_form_location_suggests"
          aria-owns="search_form_location_suggests"
          role="combobox"
          type="text"
          id="search_form_location"
          placeholder={global.Translator.trans(
            "locationform.location_placeholder",
            {},
            "js"
          )}
          className="inputfield__inputcontainer-control pl-8"
          autoComplete="off"
          value={location || ""}
          onInput={handleInput}
          onFocus={handleFocus}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          height="24"
          width="24"
          className="absolute left-2.5 w-4 h-4 block top-5.5 hover:text-brandcopy-500 pointer-events-none"
        >
          <path
            d="M12 0a9.51 9.51 0 0 0 -9.5 9.5C2.5 16.05 9 22 11 23.65a1.49 1.49 0 0 0 1.92 0C15 22 21.5 16.05 21.5 9.5A9.51 9.51 0 0 0 12 0Zm0 14.5a5 5 0 1 1 5 -5 5 5 0 0 1 -5 5Z"
            fill="currentColor"
            strokeWidth="1"
          ></path>
        </svg>
        {location !== null && location !== "" && (
          <button
            type="button"
            className="absolute right-3 top-5 text-brandcopy-700 hover:text-brandcopy-900 transition-all duration-150 ease-in-out cursor-pointer"
            onClick={handleReset}
          >
            <span className="sr-only">
              {global.Translator.trans("locationform.location_reset", {}, "js")}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
